// src/services/modulePermission/ModulePermission.ts
// Route-guard cấp trang: xác thực path hiện tại có được phép truy cập không.
// Trước đây (xem mục 8, README_SERCURITY.md) mỗi lần đổi route đều gọi API `getMyAllowedPaths()` —
// dữ liệu được BE cache Redis theo roleId (RoleAllowedPathsCacheService, đã xác nhận cache-aside
// đúng chuẩn ở mục 9.5) nên đủ nhanh, nhưng vẫn tốn 1 round-trip mỗi lần chuyển trang.
// Từ mục 9, README_SERCURITY.md: allowedPaths được nạp 1 lần vào Redux (slices/permission) lúc
// login/F5/mở lại trình duyệt/khi gặp 403 (xem slices/permission/thunk.ts), AuthProtected chỉ cần
// đọc đồng bộ từ store — không còn gọi API mỗi lần đổi route.

import { PermissionState } from "slices/permission/reducer";

// "/" không phải là 1 trang thật (không gắn với Module.Url nào ở BE) — nó chỉ là điểm vào để
// DefaultRedirect (Routes/DefaultRedirect.tsx) tính toán trang ĐẦU TIÊN mà quyền hiện tại được phép
// xem rồi điều hướng tiếp, nên phải luôn cho qua bước check quyền này (nếu không sẽ bị chặn ngay tại
// "/" trước khi kịp tính redirect, y hệt lỗi 403 cứng /dashboard mà nó thay thế).
const ALWAYS_ALLOWED = new Set<string>([
  "/",
  "/change-password",
  "/access-denied",
  "/logout",
]);

const normalize = (pathname: string): string => {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
};

export class ModulePermission {
  /**
   * Xác thực path hiện tại có được phép truy cập không — đọc đồng bộ từ Redux permission state
   * (đã được nạp trước bởi fetchMyPermissions). Gọi khi permission.loaded === true.
   */
  static isAllowed(pathname: string, permission: PermissionState): boolean {
    const path = normalize(pathname);
    if (ALWAYS_ALLOWED.has(path)) return true;
    if (permission.isFullAccessPaths) return true;

    return permission.allowedPaths.map(normalize).includes(path);
  }
}
